export default {
  cta: "Create My Calendar",
  processing: "Processing...",
  error: "Something's wrong... please review your answers :)",
};